import { useLDClient } from 'launchdarkly-react-client-sdk'
import { FeatureFlag } from 'src/types/featureFlags'

export const useFeatureFlag:(featureFlag: FeatureFlag) => boolean = (featureFlag: FeatureFlag) => {
  const ldClient = useLDClient()
  return ldClient?.variation(featureFlag.key, featureFlag.defaultValue)
}
